import { DataImage } from "@/types/types"

export const extractYouTubeId = (url: string): string => {
  if (!url) return ""
  const patterns = [
    /(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?v=([a-zA-Z0-9_-]{11})/,
    /(?:https?:\/\/)?(?:www\.)?youtu\.be\/([a-zA-Z0-9_-]{11})/,
    /(?:https?:\/\/)?(?:www\.)?youtube\.com\/embed\/([a-zA-Z0-9_-]{11})/,
    /(?:https?:\/\/)?(?:www\.)?youtube\.com\/.*[?&]v=([a-zA-Z0-9_-]{11})/,
  ]

  for (const pattern of patterns) {
    const match = url.match(pattern)
    if (match && match[1]) return match[1]
  }

  return ""
}

export const getYouTubeThumbnail = (
  urlOrId: string,
  quality: "default" | "hqdefault" | "mqdefault" | "sddefault" | "maxresdefault" = "hqdefault",
): string => {
  const videoId = urlOrId.length === 11 ? urlOrId : extractYouTubeId(urlOrId)
  if (!videoId) return ""
  return `https://img.youtube.com/vi/${videoId}/${quality}.jpg`
}

export const getYouTubeEmbedUrl = (urlOrId: string): string => {
  const videoId = urlOrId.length === 11 ? urlOrId : extractYouTubeId(urlOrId)
  if (!videoId) return ""
  return `https://www.youtube.com/embed/${videoId}?rel=0&autoplay=1`
}

export const extractPlaylistId = (url: string): string => {
  if (!url) return ""
  try {
    const u = new URL(url)
    const list = u.searchParams.get("list")
    return list || ""
  } catch {
    const match = url.match(/[?&]list=([a-zA-Z0-9_-]+)/)
    return match?.[1] || ""
  }
}

export const createDataImageFromUrl = (url: string, videoId: number, title: string, createdAt: string, updatedAt: string): DataImage => {
  return {
    id: videoId,
    attributes: {
      name: title,
      width: 1280,
      height: 720,
      formats: {
        large: { url, width: 1280, height: 720, name: "", hash: "", ext: ".jpg", mime: "image/jpeg", size: 0, sizeInBytes: 0 },
        medium: { url, width: 640, height: 360, name: "", hash: "", ext: ".jpg", mime: "image/jpeg", size: 0, sizeInBytes: 0 },
        thumbnail: { url, width: 320, height: 180, name: "", hash: "", ext: ".jpg", mime: "image/jpeg", size: 0, sizeInBytes: 0 },
        small: { url, width: 500, height: 281, name: "", hash: "", ext: ".jpg", mime: "image/jpeg", size: 0, sizeInBytes: 0 },
      },
      hash: "",
      ext: ".jpg",
      mime: "image/jpeg",
      size: 0,
      url, 
      provider: "youtube",
      createdAt,
      updatedAt,
    },
  }
}
